<template>
  <SectionPanel
    :step="0"
    :candidate="candidate"
    description="Identidad, contacto, familia y el puesto al que aplica."
    @edit="(step) => $emit('edit', step)"
  >
    <InlineSectionEditor
      ref="editor"
      :step="0"
      :candidate="candidate"
      :user-email="userEmail"
      @dirty="(value) => $emit('dirty', value)"
      @live="(value) => $emit('live', value)"
      @avatar-uploaded="(uploaded) => $emit('avatar-uploaded', uploaded)"
      @email-changed="(value) => $emit('email-changed', value)"
      @saved="(step) => $emit('saved', step)"
      @autosaved="(event) => $emit('autosaved', event)"
      @autosave-blocked="(missing) => $emit('autosave-blocked', missing)"
      @autosave-failed="(message) => $emit('autosave-failed', message)"
    />
  </SectionPanel>
</template>

<script>
import InlineSectionEditor from "./InlineSectionEditor.vue";
import SectionPanel from "./SectionPanel.vue";

// Datos personales: its fields are always on screen and edited right here.
export default {
  name: "PortalPersonalTab",
  components: { InlineSectionEditor, SectionPanel },
  props: {
    candidate: { type: Object, required: true },
    userEmail: { type: String, default: "" },
  },
  methods: {
    // Hands a new profile photo to the section's form (see InlineSectionEditor's changeAvatar()).
    changeAvatar(file) {
      return this.$refs.editor ? this.$refs.editor.changeAvatar(file) : Promise.resolve(false);
    },
    // Saves what is waiting before leaving the section (see InlineSectionEditor's flush()).
    flush() {
      return this.$refs.editor ? this.$refs.editor.flush() : Promise.resolve(true);
    },
  },
};
</script>
